import * as React from 'react'

function SvgTimeOffIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M45.5 8.75h-35a1.75 1.75 0 00-1.75 1.75v35c0 .967.784 1.75 1.75 1.75h35a1.75 1.75 0 001.75-1.75v-35a1.75 1.75 0 00-1.75-1.75zM38.5 5.25v7M17.5 5.25v7M8.75 19.25h38.5M27.404 25.021l-9.532 9.532M27.404 34.553l-9.532-9.532"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={42.702}
        cy={43.511}
        fill="#fff"
        stroke="currentColor"
        strokeWidth={1.5}
        r={9.267}
      />
      <path
        d="M42.702 37.553v5.958h3.972"
        stroke="currentColor"
        strokeWidth={1.3}
      />
      <path
        d="M34 24h10M34 27h10M34 30h4"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default SvgTimeOffIcon
